import { UnsupportedPinComponentSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { colorSets } from '../../foundations/colorSets/colorSets';
import { mapOriginalTypeToIcon } from './unsupportedPinComponent.utils';

export interface UnsupportedPinComponentProps {
  settings: UnsupportedPinComponentSettings;
}

export const UnsupportedPinComponent: React.FC<UnsupportedPinComponentProps> = ({ settings }) => {
  const originalTypeIcon = mapOriginalTypeToIcon(settings.originalType);
  return (
    <UnsupportedPinComponentWrapper>
      <StyledContent>{originalTypeIcon}</StyledContent>
    </UnsupportedPinComponentWrapper>
  );
};

const UnsupportedPinComponentWrapper = styled.div`
  background: ${colorSets.unsupported.fill};
  color: ${colorSets.unsupported.on};
  border: 2px dashed ${colorSets.unsupported.stroke};
  width: 100%;
  height: 100%;
`;

const StyledContent = styled.div<{ bold?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
